import { useQuery } from "@tanstack/react-query";

import { mediaProviderApi } from "../api";

/**
 * 拉 provider 能力(ratios/tiers/enabled),给海报三页 + 视频约束 + gallery filter 用。
 * 5 分钟 stale + 30 分钟 cache(capabilities 跟 model 版本绑定,变化频率极低)。
 */
export function useProviderCapabilities() {
  return useQuery({
    queryKey: ["poster-provider-capabilities"],
    queryFn: () => mediaProviderApi.getProviderCapabilities(),
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
    // 0926 旅程冒烟:挂了时全局兜底 toast 会把后端原文(曾含「I/O error on GET request for
    // "http://127.0.0.1:9/…"」)直接弹给用户。唯一消费方出图页(useFreeCreateConstraints)
    // 自己接了错误态:底栏「价格待系统核算」+ 按钮禁用 + 走公共错误层 toast 一次。
    meta: { suppressGlobalErrorToast: true },
  });
}
